<template>
  <div
    v-if="isVisible"
    class="relative top-0 left-0 right-0 z-50 bg-black text-white py-3 px-4"
  >
    <div class="max-w-7xl mx-auto flex items-center justify-center gap-4">
      <div class="flex items-center gap-2 sm:gap-3 text-center flex-wrap justify-center">
        <span class="text-md sm:text-lg font-black">{{ payload?.title }}</span>
        <span class="hidden sm:block text-sm sm:text-base">{{ payload?.longDescription }}</span>
        <span class="block sm:hidden text-sm sm:text-base">{{ payload?.shortDescription }}</span>
        <code
          class="
            relative group
            bg-white
            text-black
            pr-2
            pl-2 sm:pl-7
            py-0.5 sm:py-1
            rounded
            font-mono
            text-sm
            inline-flex
            items-center
            gap-2
          "
        >
          {{ payload?.code }}
          <a-tooltip class="hidden sm:block">
            <template #title>Copy</template>
            <button
              class="opacity-0 group-hover:opacity-100 transition-opacity
                text-black hover:text-gray-600"
              aria-label="Copy code"
              @click="copyCode"
            >
              <i class="fa-solid fa-copy" />
            </button>
          </a-tooltip>
        </code>
      </div>

      <button
        class="absolute right-4 top-1/2 -translate-y-1/2 text-white hover:text-gray-300 transition-colors"
        aria-label="Close banner"
        @click="dismissBanner"
      >
        <i class="fa-solid fa-xmark" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { message } from 'ant-design-vue';
import { usePostHog } from '../../composables/usePosthog';

const STORAGE_KEY = ref('sale-banner-dismissed');

const isVisible = ref(false);
const { posthog } = usePostHog();

const payload = ref<any>(null);

onMounted(() => {
  posthog.onFeatureFlags(() => {
    const remoteEnabled = posthog?.isFeatureEnabled('sale-banner') || false;
    if (remoteEnabled) {
      payload.value = posthog?.getFeatureFlagPayload('sale-banner');
      STORAGE_KEY.value = 'sale-banner-dismissed-' + payload.value?.code;

      isVisible.value = true;
      const dismissed = localStorage.getItem(STORAGE_KEY.value);
      if (dismissed === 'true') {
        isVisible.value = false;
      }
    }
  });
});

const dismissBanner = () => {
  isVisible.value = false;
  localStorage.setItem(STORAGE_KEY.value, 'true');
};

const copyCode = async () => {
  try {
    await navigator.clipboard.writeText(payload.value?.code);
    message.success('Copied to clipboard');
  } catch (err) {
    console.error('Failed to copy code:', err);
    message.error('Failed to copy code');
  }
};
</script>
